@if (call) {
    <div
        *transloco="let t; read: 'ACTIVE_CALL'"
        class="flex w-full flex-0 items-center gap-3 border-b bg-primary-50 px-4 py-2 text-primary-900 md:px-6 dark:bg-primary-900 dark:text-primary-50 print:hidden"
        role="status"
    >
        <mat-icon
            class="icon-size-5 text-current"
            [svgIcon]="call.direction === 'inbound' ? 'heroicons_outline:phone-arrow-down-left' : 'heroicons_outline:phone-arrow-up-right'"
        ></mat-icon>
        <span class="font-medium">{{ t('ON_CALL_WITH') }}</span>
        <span class="truncate">
            {{ call.name || call.phone || t('UNKNOWN_CALLER') }}
            @if (call.name && call.phone) {
                <span class="text-secondary">· {{ call.phone }}</span>
            }
        </span>
        <span class="font-mono tabular-nums text-secondary">{{ elapsed }}</span>
        <span class="flex-auto"></span>
        @if (link) {
            <a class="font-medium underline" [routerLink]="link">
                {{ t(call.userId ? 'OPEN_360' : 'OPEN_LEAD') }}
            </a>
        } @else {
            <span class="text-secondary">{{ t('NO_RECORD') }}</span>
        }
    </div>
}
